fx.ns("filters.photofilters", class ContrastFilter extends filters.photofilters.BaseFilter {
    
    constructor(parameters)
    {
        super(parameters);

        this.amount = this.params.amount;
        this.vignette = this.params.vignette;
        
    };

    apply(SVGElement)
    {
        super.apply(SVGElement)
        
        if (this.vignette)
        {
            let baseSVG = SVGElement.parent();

            let gradient = baseSVG.gradient('radial', function(stop) {
              stop.at(0.2, 'rgba(255,255,255,1)')
              stop.at(0.7, 'rgba(0,0,0,1)')
            })

            
            let ellipse = baseSVG.ellipse(SVGElement.width() * 1.5, SVGElement.height() * 1.5)
                                     .move(- SVGElement.width()  / 4, -SVGElement.height() / 4)
                                     .fill(gradient)
                                     let mask = baseSVG.mask();

            mask.add(ellipse)
            
            SVGElement.maskWith(mask);

            this.elements.push(gradient);
            this.elements.push(mask);
            this.elements.push(ellipse);
        }

	};

    filterFCN(add)
    {
         add.componentTransfer({
                rgb: { type: 'linear', slope: this.amount, intercept: -(0.3 * this.amount) + 0.3 }
            })
    }

    resize(width, height)
    {
         for (let i = 0; i < this.elements.length; i++)
         {
            if (this.elements[i].type == "ellipse")
            {
                this.elements[i].size( width *1.5, height * 1.5)
                                .move(- width / 4, -height / 4);
            }
        }
    }



});
